import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faClose } from '@fortawesome/pro-regular-svg-icons';

import { Media } from '@eiq/files/models';

import { FileType, ImageTypes } from '@empathy/global/data';

@Component({
  selector: 'empathy-stimulus-preview-dialog',
  templateUrl: 'stimulus-preview-dialog.component.html',
  styleUrls: ['./stimulus-preview-dialog.component.scss']
})
export class StimulusPreviewDialogComponent implements OnInit {
  faClose = faClose;
  fileType = FileType;
  imageTypes = ImageTypes as string[];

  constructor(
    private dialogRef: MatDialogRef<StimulusPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Media
  ) {}

  ngOnInit(): void {
    this.dialogRef.updateSize('560px', '520px');
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
